module.exports = __webpack_public_path__ + "static/offer-fizjoteriapia-image-1-1e3cf12a23e35571be1e8bd23b374165.png";